export default {
  // Hero section
  'hero.title': 'プロフェッショナルなオンラインタイマーツール',
  'hero.subtitle': 'あなたのニーズに最適なタイミングツールを選択',

  // Tool cards
  'timer.title': 'タイマー',
  'timer.description': '仕事、勉強、生活のためのカウントダウンタイマー',
  'timer.longDescription': '生産性、料理、時間管理のためのカウントダウンタイマー',
  'timer.button': 'タイマーを開始',

  'stopwatch.title': 'ストップウォッチ',
  'stopwatch.description': '高精度タイミングツール',
  'stopwatch.longDescription': 'スポーツ、トレーニング、精密タイミングのための高精度ストップウォッチ',
  'stopwatch.button': 'ストップウォッチを開始',

  'worldclock.title': '世界時計',
  'worldclock.description': '世界中のタイムゾーンを表示',
  'worldclock.longDescription': 'インテリジェントなタイムゾーン計算でグローバル主要都市の時刻をリアルタイム表示',
  'worldclock.button': '世界時計を表示',

  // Features section
  'features.title': 'なぜtimer.todayを選ぶのか？',
  'features.reliable.title': '信頼性と精度',
  'features.reliable.desc': 'ブラウザベースの信頼性とミリ秒精度のタイミング',
  'features.crossPlatform.title': 'クロスプラットフォーム',
  'features.crossPlatform.desc': 'デスクトップ、タブレット、モバイルデバイスでシームレスに動作',
  'features.smartNotifications.title': 'スマート通知',
  'features.smartNotifications.desc': '時間終了時にサウンドアラートとデスクトップ通知',
  'features.easyToUse.title': '使いやすい',
  'features.easyToUse.desc': 'すべてのユーザーに直感的な操作のクリーンなインターフェース',

  // Keywords section
  'keywords.timer': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
